export enum WidgetInputAlias {
    StaticVariables = "staticVariables",
    WidgetSourceId = "widgetSourceId",
    WidgetType = "widgetType",
    Exportable = "exportable",
    Output = "output",
}